var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteDetail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8211 9.64282H9.64258V16.7143H10.8211V9.64282Z",
    fill: "#020002"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3563 9.64282H13.1777V16.7143H14.3563V9.64282Z",
    fill: "#020002"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92773 6.10693V7.28551H6.10631V19.0712C6.10631 19.3838 6.23048 19.6836 6.4515 19.9046C6.67253 20.1256 6.9723 20.2498 7.28488 20.2498H16.7134C17.026 20.2498 17.3258 20.1256 17.5468 19.9046C17.7678 19.6836 17.892 19.3838 17.892 19.0712V7.28551H19.0706V6.10693H4.92773ZM7.28488 19.0712V7.28551H16.7134V19.0712H7.28488Z",
    fill: "#020002"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3569 3.74976H9.64258V4.92833H14.3569V3.74976Z",
    fill: "#020002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDetail);
export default __webpack_public_path__ + "static/media/deleteDetail.5991ab5c7d94aa312293557146282068.svg";
export { ForwardRef as ReactComponent };